// Mirrors backend SurveyAnswerTextLookup (feedback-survey-service).
// SurveyType: 0 = pickup, 1 = delivery.
const ANSWER_TEXT = {
  pickup: {
    LikeBest: {
      0: 'The order was ready on time',
      1: 'I received exactly what I ordered',
      2: 'The food was delicious',
      3: 'Great value for money'
    },
    WhatWentWrong: {
      0: "Order wasn't ready on time",
      1: 'Missing items',
      2: 'Packaging issues',
      3: 'Food quality',
      4: 'Restaurant was closed'
    }
  },
  delivery: {
    LikeBest: {
      0: 'Food was delivered faster than I expected',
      1: 'I received exactly what I ordered',
      2: 'The food was delicious',
      3: 'Great value for money'
    },
    WhatWentWrong: {
      0: 'Missing items',
      1: 'Packaging issues',
      2: 'Food quality',
      3: 'Delivery issues'
    },
    DeliveryLikeBest: {
      0: 'Fast delivery',
      1: 'Friendly service',
      2: 'Efficient courier',
      3: 'Good communication'
    },
    DeliveryWhatWentWrong: {
      0: 'Delivery never arrived',
      1: 'Delivery was late',
      2: 'Bad drop-off',
      3: 'Bad communication'
    }
  }
};

const GOOD_NAMES = new Set(['LikeBest', 'DeliveryLikeBest']);
const BAD_NAMES = new Set(['WhatWentWrong', 'DeliveryWhatWentWrong']);

// Legacy Pickup/Delivery tabs used a fixed set of value indices per survey type.
const LEGACY_ITEMS = {
  pickup: {
    bad: [0, 1, 2, 3],
    good: [0, 1, 2, 3]
  },
  delivery: {
    bad: [0, 1, 2],
    good: [0, 1, 2, 3]
  }
};

const computePopularFromSurveyAnswers = (surveyAnswers, orderTypeId) => {
  if (!Array.isArray(surveyAnswers) || orderTypeId === 0) return [];
  const surveyType = orderTypeId === 2 ? 0 : 1;
  const lookup = surveyType === 0 ? ANSWER_TEXT.pickup : ANSWER_TEXT.delivery;
  return surveyAnswers
    .filter((a) => GOOD_NAMES.has(a.Name) || BAD_NAMES.has(a.Name))
    .map((a) => {
      const text = lookup[a.Name]?.[a.Value];
      if (!text) return null;
      return {
        Count: a.Occurrence || 0,
        Type: GOOD_NAMES.has(a.Name) ? 0 : 1,
        SurveyType: surveyType,
        Text: text
      };
    })
    .filter(Boolean)
    .sort((a, b) => b.Count - a.Count)
    .slice(0, 4);
};

const findOccurrence = (surveyAnswers, name, value) =>
  surveyAnswers?.find((el) => el.Name === name && el.Value === value)
    ?.Occurrence || 0;

// Returns { bad: [{text, count}], good: [{text, count}] } for the given order type.
// orderTypeId: 1 = delivery, 2 = pickup. Returns null for All.
export const computeFeedbackByRating = (surveyAnswers, orderTypeId) => {
  if (!Array.isArray(surveyAnswers) || orderTypeId === 0) return null;
  const kind = orderTypeId === 2 ? 'pickup' : 'delivery';
  const lookup = ANSWER_TEXT[kind];
  const items = LEGACY_ITEMS[kind];
  const build = (name, values) =>
    values
      .map((v) => {
        const text = lookup[name]?.[v];
        if (!text) return null;
        return {text, count: findOccurrence(surveyAnswers, name, v)};
      })
      .filter(Boolean);
  return {
    bad: build('WhatWentWrong', items.bad),
    good: build('LikeBest', items.good)
  };
};

export default computePopularFromSurveyAnswers;
